import type { CompleteUser } from '../types';

export function canManageAccountSettings(
  user: Pick<CompleteUser, 'accessLevel'> | null | undefined
): boolean {
  return user?.accessLevel === 'OWNER' || user?.accessLevel === 'ADMIN';
}

export function canAccessSecuritySettings(
  user: Pick<CompleteUser, 'accessLevel' | 'company'> | null | undefined
): boolean {
  return (
    canManageAccountSettings(user) ||
    user?.company?.authenticate_mode === 'Default'
  );
}
